import { render, staticRenderFns } from "./BedInTwin.vue?vue&type=template&id=5437f9d6&"
import script from "./BedInTwin.vue?vue&type=script&lang=js&"
export * from "./BedInTwin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports